export default __webpack_public_path__ + "static/media/yo_1.43367cdd.mp3";